const isUsableCode = (value: unknown) => {
  if (value === null || value === undefined) return false;
  const text = String(value).trim();
  return text.length > 0 && text !== 'null' && text !== 'undefined';
};

const formatYearRange = (input?: string | String) => {
  if (!input) return '';
  return `${input}`.replace(/\s*-\s*/g, '-').trim();
};

export const buildCourseSuggestParams = (
  school: any,
  searchKey?: string | String,
  schoolYear?: string | String
) => {
  const course_title = `${searchKey ?? ''}`.trim();
  const course_list_year = formatYearRange(schoolYear);
  const college_board_code =
    school?.college_board_code || school?.code || school?.high_school_code || '';
  const school_name =
    school?.school_name || school?.uc_name || school?.high_school_name || school?.cm_name || '';

  const params: {
    course_title: string;
    course_list_year: string;
    college_board_code?: string;
    school_name?: string;
    school_id?: string;
  } = { course_title, course_list_year };

  if (isUsableCode(college_board_code)) {
    params.college_board_code = String(college_board_code).trim();
    return params;
  }
  if (isUsableCode(school_name)) {
    params.school_name = String(school_name).trim();
    return params;
  }
  if (school?.id != null && /^\d+$/.test(String(school.id).trim())) {
    params.school_id = String(school.id).trim();
  }
  return params;
};
